import Immutable from 'seamless-immutable';
import { equals, isNil, isEmpty, path, pathOr, propOr } from 'ramda';
import { createSelector } from 'reselect';
import { ConvergentBillerOrderDetailsSelector } from './customer.convergent.biller.selectors';
import { ORDER_TYPES } from '../../components/customer/orderHistory/orderDetails/order.details.constants';
var EMPTY_OBJECT = Immutable({});
export var CurrentDetailsGiftOrderInfoSelector = createSelector([ConvergentBillerOrderDetailsSelector], function (currentDetails) {
  if (isNil(currentDetails) || isEmpty(currentDetails)) {
    return EMPTY_OBJECT;
  }
  return {
    orderId: path(['Id'], currentDetails),
    giftMessage: path(['GiftRedemption', 'SenderMessage'], currentDetails),
    recipientEmail: path(['GiftRedemption', 'RecipientEmail'], currentDetails),
    recipientName: path(['GiftRedemption', 'RecipientName'], currentDetails),
    isGiftOrder: equals(path(['Type'], currentDetails), ORDER_TYPES.GIFT),
    senderName: path(['GiftRedemption', 'SenderName'], currentDetails),
    senderEmail: path(['GiftRedemption', 'SenderEmail'], currentDetails),
    isRevoked: !isNil(path(['GiftRedemption', 'Revoked'], currentDetails)),
    revokeReasonName: path(['GiftRedemption', 'RevokeReasonName'], currentDetails),
    isNotified: pathOr([], ['GiftRedemption', 'Notifications'], currentDetails).length > 0,
    statusName: path(['GiftRedemption', 'StatusName'], currentDetails)
  };
});
var ResendGiftNotificationSelector = function ResendGiftNotificationSelector(store) {
  return store.customercare.recoverableUiState.resendGiftNotification;
};
export var ResendGiftNotificationInfoSelector = createSelector([ResendGiftNotificationSelector], function (resendGiftNotification) {
  return propOr(EMPTY_OBJECT, 'giftOrderInfo', resendGiftNotification);
});
export var ResendGiftNotificationErrorSelector = createSelector([ResendGiftNotificationSelector], function (resendGiftNotification) {
  return propOr(null, 'resendGiftNotificationError', resendGiftNotification);
});
export var IsResendingGiftNotificationSelector = createSelector([ResendGiftNotificationSelector], function (resendGiftNotification) {
  return propOr(false, 'isResendingGiftNotification', resendGiftNotification);
});